import angular from 'angular'

angular.module("core.application.main").directive("core.application.main.directive.emailAddress", function() {

    var expose = {};
    expose.require = "ngModel";
    expose.restrict = "A";

    // This directive validates a loose email check, which ensures:
    // There is at least one "@" symbol and one "." symbol with any number of characters
    // before and after. The directive is primarily for fixing the built in type="email" browser validation,
    // which doesn't invalidate the incorrect email format of "user@gmail"

    // Allowed:
    //     user@gmail.com
    //     user@gmail.c
    //     r@gmail.com
    //     r@g.c

    // Not allowed:
    //     user@gmail
    //     @gmail
    //     .com

    // This directive should be used with the type="email" input field to ensure non-ascii characters
    // and other formats like the following are considered invalid:
    //     user@user@gmail.com, user@gmail..com

    expose.link = function($scope, element, attributes, controller) {

        var validate = function(value) {
            value = value || "";
            // \S+ means one or more non-whitespace characters
            // PAYL-7886 Also allow an empty email address.
            // If the email address is required, use ng-required as well.
            controller.$setValidity("format", value.match(/\S+@\S+\.\S+/) !== null || value === "");
            return value;
        };

        controller.$parsers.unshift(validate);
        controller.$formatters.unshift(validate);
    };

    return expose;

});
